const TOOLKIT = ['Spreadsheets', 'Business apps', 'Custom software', 'Data', 'AI'];

export function WhyNorthforge() {
  return (
    <section id="why" className="bg-bg2 px-6 py-24 transition-colors duration-[450ms]">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 items-start gap-8 min-[900px]:grid-cols-2 min-[900px]:gap-16">
        <div>
          <span className="text-xs tracking-[0.3em] text-accent">03 — WHY NORTHFORGE</span>
          <h2
            data-reveal
            className="m-0 mt-3.5 font-display text-[clamp(30px,3.6vw,46px)] font-semibold leading-[1.1] tracking-[-0.02em]"
          >
            We start with understanding, not code.
          </h2>
          <div className="mt-9 flex gap-4.5">
            <div data-reveal className="flex-1 rounded-2xl border border-[var(--line)] p-5">
              <div className="mb-1.5 font-display text-lg text-accent">North</div>
              <p className="m-0 text-[14.5px] leading-[1.55] text-dim">
                The goal is always what genuinely serves you — not what's easiest to sell.
              </p>
            </div>
            <div data-reveal className="flex-1 rounded-2xl border border-[var(--line)] p-5">
              <div className="mb-1.5 font-display text-lg text-accent">Forge</div>
              <p className="m-0 text-[14.5px] leading-[1.55] text-dim">
                Getting there means working closely in the problem, not rushing to a quick fix.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-3 min-[900px]:pl-6">
          <p data-reveal className="m-0 mb-[22px] text-balance text-[17px] leading-[1.7] text-dim">
            Most technical work starts with "what do you want built." We start with "what's
            actually slowing you down" — digging into the real process, the edge cases, and the
            people who use it every day, before writing a line of code.
          </p>
          <p data-reveal className="m-0 mb-[30px] text-balance text-[17px] leading-[1.7] text-dim">
            Built on a broad technical toolkit — from spreadsheets and business apps to custom
            software, data, and AI — so the right solution is chosen for the problem, not the
            other way around.
          </p>
          <div data-reveal className="flex flex-wrap gap-2">
            {TOOLKIT.map((item) => (
              <span
                key={item}
                className="rounded-full border border-[var(--line)] px-3.5 py-2 text-[13.5px] text-dim"
              >
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
